import {Tabs} from 'platform/components';
import {Box} from 'platform/foundation';

import {useParams} from 'react-router-dom';

import {useGetBranchV2Query} from '@dms/api/base';
import i18n from '@dms/i18n';

import {buildArray} from 'shared/web';

import {CategoryOpeningHoursForm} from './CategoryOpeningHoursForm';

type OpeningHoursTab = {
  id: string;
  category: 'salesOpeningHours' | 'workshopOpeningHours' | 'rentalOpeningHours';
  titleKey: string;
  descriptionKey: string;
};

const SALES_TAB: OpeningHoursTab = {
  id: 'sales',
  category: 'salesOpeningHours',
  titleKey: 'entity.branch.labels.openingHoursSales',
  descriptionKey: 'entity.branch.labels.openingHoursSalesDescription',
};

const WORKSHOP_TAB: OpeningHoursTab = {
  id: 'workshop',
  category: 'workshopOpeningHours',
  titleKey: 'entity.branch.labels.openingHoursWorkshop',
  descriptionKey: 'entity.branch.labels.openingHoursWorkshopDescription',
};

const RENTAL_TAB: OpeningHoursTab = {
  id: 'rental',
  category: 'rentalOpeningHours',
  titleKey: 'entity.branch.labels.openingHoursRental',
  descriptionKey: 'entity.branch.labels.openingHoursRentalDescription',
};

interface OpeningHoursProps {
  canReadBusinessCase: boolean;
  isWorkshopModuleEnabled: boolean;
  canReadRentalVehicle: boolean;
}

export function OpeningHours(props: OpeningHoursProps) {
  const {id: branchId} = useParams<{id: string}>();

  const {data: branch} = useGetBranchV2Query({id: branchId ?? ''}, {skip: !branchId});

  const visibleTabs = buildArray<OpeningHoursTab>()
    .when(props.canReadBusinessCase, SALES_TAB)
    .when(props.isWorkshopModuleEnabled, WORKSHOP_TAB)
    .when(props.canReadRentalVehicle, RENTAL_TAB);

  const defaultTabId = visibleTabs[0]?.id;

  return (
    <Box paddingTop={6}>
      {/* isLazy prop is necessary for the correct unsavedChanges behavior when navigating between tabs */}
      <Tabs
        variant="condensed"
        defaultTabId={defaultTabId}
        isLazy
        tabs={visibleTabs.map((tab) => ({
          id: tab.id,
          title: i18n.t(tab.titleKey),
          // eslint-disable-next-line eag/prefer-show -- Pre-existing violation
          content: branchId ? (
            <CategoryOpeningHoursForm
              category={tab.category}
              branchId={branchId}
              description={i18n.t(tab.descriptionKey)}
              branchOpeningHours={branch?.[tab.category]}
            />
          ) : null,
        }))}
      />
    </Box>
  );
}
